import { deepAnalysisApi } from '../service';
import { SeoAuditStructure, SeoAudit, FetchDomainAuditParams, FetchUrlAuditParams } from './types';

const auditReportApi = deepAnalysisApi.injectEndpoints({
    endpoints: (builder) => ({
        fetchAuditStructure: builder.query<SeoAuditStructure, void>({
            query: () => {
                return {
                    method: 'GET',
                    url: '/on-page-seo/audit/structure',
                };
            },
        }),

        fetchDomainAudit: builder.query<SeoAudit, FetchDomainAuditParams>({
            query: (args) => {
                const { w_guid } = args;

                return {
                    method: 'GET',
                    url: `/on-page-seo/audit/domain/${w_guid}`,
                };
            },

            providesTags: (result, error, args) => [{ type: 'DomainAudits', id: args.w_guid }],
        }),

        fetchUrlAudit: builder.query<SeoAudit, FetchUrlAuditParams>({
            query: (args) => {
                const { w_guid, url_guid } = args;

                return {
                    method: 'GET',
                    url: `/on-page-seo/audit/url/${w_guid}/${url_guid}`,
                };
            },

            providesTags: (result, error, args) => [
                { type: 'UrlAudits', id: args.w_guid },
                { type: 'UrlAudits', id: `${args.w_guid}_${args.url_guid}` },
            ],
        }),
    }),
});

export const { useFetchAuditStructureQuery, useFetchDomainAuditQuery, useFetchUrlAuditQuery } = auditReportApi;
